/**
 * The Sale Day launcher (ADR-44). Sign in, and instead of a dashboard:
 * "What are you working on?" - one card per station this person can work.
 * One available station skips the question entirely; the launcher routes
 * straight there. Zero stations says so plainly.
 *
 * Each card pins `mode` + `as` (the LEAST privileged role that works the
 * station) into the target URL; the server verifies the role on every
 * request. Switching stations later happens from any page header.
 */

import { bootSession, NeedsSignIn, type Session } from './session.js';
import { el, setChildren } from './dom.js';
import { apiBase } from './observer.js';
import { launchDecision, modeHref, type WorkMode } from './work-modes.js';
import { initTheme } from './theme.js';

const params = new URLSearchParams(location.search);
const API = apiBase(params);
const $ = (id: string): HTMLElement => document.getElementById(id)!;
const say = (t: string): void => { $('msg').textContent = t; };

void (async () => {
  let session: Session;
  try {
    session = await bootSession({ apiBase: API, params, signInUrl: `${API.replace(':4100', ':4000')}/staff-signin.html` });
  } catch (e) {
    if (e instanceof NeedsSignIn) { location.href = e.signInUrl; return; }
    say(String((e as Error).message));
    return;
  }
  $('who').textContent = session.actorId;

  const decision = launchDecision(session.roles);
  if (decision.kind === 'none') {
    say('No sale-day stations are assigned to your account. Ask the sale office to assign your roles.');
    return;
  }
  if (decision.kind === 'go') {
    location.replace(modeHref(decision.mode, location.search, session.roles));
    return;
  }
  $('ask').style.display = 'block';
  const card = (m: WorkMode): HTMLElement => {
    const c = el('button', { class: 'card' }, el('span', { class: 'name', text: m.label }), el('span', { class: 'desc', text: m.desc }));
    c.addEventListener('click', () => { location.href = modeHref(m, location.search, session.roles); });
    return c;
  };
  setChildren($('cards'), ...decision.modes.map(card));
})();


// Light/dark, remembered across the console (theme.ts).
initTheme();
